<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Kas Keluar</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="12">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterTanggalMulai" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterTanggalAkhir" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="12">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                                <multiselect
                                class="ml-0"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterVoidStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="voidStatus" :options="statusKasKeluar" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih status --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Cari 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="dataKasKeluar" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas keluar.
                </template>
                <template v-slot:cell(diajukanPada)="row">
                    <p class="mb-0">{{$helper.changeDateFormat(row.item.diajukanPada)}}</p>
                    <div v-if="row.item.diajukanPada != null" class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.diajukanPada)}}</div>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <div v-if="row.item.diajukanOleh != null">{{ row.item.diajukanOleh }}</div>
                    <div v-if="row.item.cabang != null" class="smallText text-muted">{{ row.item.cabang }}</div>
                </template>
                <template v-slot:cell(nominal)="row">
                    <p class="mb-0">Rp. {{$helper.addThousandSeparator(row.item.nominal)}}</p>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING'">{{ row.item.status }}</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">{{ row.item.status }}</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'DITOLAK'">{{ row.item.status }}</b-badge>
                    <b-badge variant="primary" v-else>{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="keringananViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Permohonan kas keluar masih menunggu untuk diproses oleh HO.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Permohonan kas keluar disetujui oleh HO. Kas cabang sudah disesuaikan sesuai dengan nominal kas keluar.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Permohonan kas keluar ditolak oleh HO. Kas cabang tidak berubah.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">BATAL</h6>
                <p class="smallText mb-0">Permohonan kas keluar dibatalkan oleh pengaju.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'approval-kas-keluar',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input: {
                show: 10,
                filterTanggalMulai: null,
                filterTanggalAkhir: null,
                filterCabang: null,
                filterStatus: null
            },
            fields: [
                { key: "diajukanPada", label: "Tanggal Pengajuan", sortable:true },
                { key: "diajukanOleh", label: "Diajukan Oleh" },
                { key: "nominal", label: "Nominal" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],
            dataKasKeluar: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusKasKeluar: [
                { id: 0, name: 'PENDING' },
                { id: 1, name: 'DITERIMA' },
                { id: 2, name: 'DITOLAK' },
                { id: 3, name: 'BATAL' }
            ],
            filter: null,
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataKasKeluar = this.$axios.get("approval-kas-keluar/"+this.query).then(response => {
                this.dataKasKeluar = response.data.data
                this.updateTotalItem(response.data.total)
            })
            
            Promise.all([getCabang, getDataKasKeluar]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Merk -----------------

        getDataKasKeluar(){
            this.toggleBusy()
            this.dataKeringanan = []
            
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) this.query = this.query + "&filterStartDate=" + this.input.filterTanggalMulai
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir)) this.query = this.query + "&filterEndDate=" + this.input.filterTanggalAkhir
            if(this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if(this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if(this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if(this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("approval-kas-keluar/"+this.query).then(response => {
                this.dataKasKeluar = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDataKasKeluar()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDataKasKeluar()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterTanggalMulai = null
            this.input.filterTanggalAkhir = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataKasKeluar()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && !this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) && (Date.parse(this.input.filterTanggalAkhir) < Date.parse(this.input.filterTanggalMulai))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getDataKasKeluar()
            }
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        }
    },

    created(){
        this.init()
        let flash = this.$helper.getFlash()
        if(flash != null) {
            this.$helper.toastSucc(this, flash)
        }
    }
}
</script>
